/* ============================================================
   ELMORE — COLLECTION ATC (LET THEME HANDLE DRAWER)
   FINAL CLEAN VERSION
   ============================================================ */

(function () {
  if (window.__ELMORE_COLLECTION_CLEAN__) return;
  window.__ELMORE_COLLECTION_CLEAN__ = true;

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form.elmore-card__quickform[data-atc-form]')) return;

    const btn = form.querySelector('button[type="submit"]');
    if (!btn) return;

    if (!btn.dataset.originalText) {
      btn.dataset.originalText = btn.textContent.trim();
    }

    btn.disabled = true;
    btn.textContent = 'Adding…';

    // Let Broadcast theme handle the submission normally
    // Do NOT preventDefault
  });

  // Restore button text after drawer updates
  document.addEventListener('cart:updated', function () {
    document.querySelectorAll('form.elmore-card__quickform button[type="submit"]').forEach(btn => {
      if (btn.dataset.originalText) {
        btn.disabled = false;
        btn.textContent = btn.dataset.originalText;
      }
    });
  });

})();
